import { Button, Form, Input } from 'antd'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { Detergent } from '@/types'
import { CreateDetergentHistoryRequest } from '@/types/apis/detergentHistories/CreateDetergentHistoryRequest'

import { SpaceCustom } from '../../style'

type Props = {
  loading: boolean
  onSubmit: (formValues: CreateDetergentHistoryRequest) => void
  getDetergentDetailResponse?: Detergent
}

type FormValues = {
  quantity: number
}

const CreateDetergentHistoryComponentForm = ({ loading, onSubmit, getDetergentDetailResponse }: Props) => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [form] = Form.useForm<FormValues>()

  const handleFinish = (values: FormValues) => {
    const formattedValues: CreateDetergentHistoryRequest = {
      detergentId: Number(id),
      quantity: values.quantity,
    }

    onSubmit(formattedValues)
  }

  useEffect(() => {
    if (getDetergentDetailResponse) {
      const data = {
        name: getDetergentDetailResponse.name,
        price: getDetergentDetailResponse.price,
        quantity: 0,
      }

      form.setFieldsValue(data)
    }
  }, [form, getDetergentDetailResponse])

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      <Form.Item label={t('components.pages.detergentHistories.create.form.name')} name="name">
        <Input disabled={true} />
      </Form.Item>

      <Form.Item label={t('components.pages.detergentHistories.create.form.price')} name="price">
        <Input type="number" disabled={true} suffix={t('components.pages.detergentHistories.create.form.priceUnit')} />
      </Form.Item>

      <Form.Item
        label={t('components.pages.detergentHistories.create.form.quantity')}
        name="quantity"
        rules={[{ required: true, message: t('components.pages.detergentHistories.create.form.requireQuantity') }]}
      >
        <Input type="number" min={0} step={1} suffix="ケース" />
      </Form.Item>

      <SpaceCustom>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            {t('components.pages.detergentHistories.create.form.submit')}
          </Button>
        </Form.Item>
      </SpaceCustom>
    </Form>
  )
}

CreateDetergentHistoryComponentForm.displayName = 'CreateDetergentHistoryComponentForm'
export default CreateDetergentHistoryComponentForm
